import { useParams } from 'react-router-dom';
import { getArticleById } from '@/mocks/article-details';
import { categories } from '@/mocks/articles';
import ArticleContent from './components/ArticleContent';
import RelatedArticles from './components/RelatedArticles';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = getArticleById(Number(id));

  const seoTitle = article
    ? `${article.title} - 911爆料网`
    : '文章不存在 - 911爆料网';
  const seoDescription = article
    ? article.excerpt
    : '911爆料网 - 网红黑料明星塌房每日吃瓜爆料追踪';
  const canonicalUrl = `https://www.911baoliao.com/article/${id}`;
  const category = article ? categories.find((c) => c.slug === article.category) : null;

  const seoData = article
    ? {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'BreadcrumbList',
            itemListElement: category
              ? [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'https://www.911baoliao.com/',
                  },
                  {
                    '@type': 'ListItem',
                    position: 2,
                    name: category.name,
                    item: `https://www.911baoliao.com/category/${category.slug}`,
                  },
                  {
                    '@type': 'ListItem',
                    position: 3,
                    name: article.title,
                  },
                ]
              : [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'https://www.911baoliao.com/',
                  },
                  {
                    '@type': 'ListItem',
                    position: 2,
                    name: article.title,
                  },
                ],
          },
          {
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            image: article.imageUrl,
            datePublished: article.date,
            author: {
              '@type': 'Person',
              name: article.author,
            },
            publisher: {
              '@type': 'Organization',
              name: '911爆料网',
              url: 'https://www.911baoliao.com/',
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': canonicalUrl,
            },
          },
        ],
      }
    : null;

  return (
    <>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={`${article?.tags.join(',') || '爆料'}${category ? `,${category.name}` : ''},911爆料网,吃瓜爆料`} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      {article && <meta property="og:image" content={article.imageUrl} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="article" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      {article && <meta name="twitter:image" content={article.imageUrl} />}
      {seoData && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seoData) }} />
      )}

      <main>
        <div className="flex flex-col lg:flex-row gap-8 max-w-7xl mx-auto px-4 md:px-6 pb-16">
          <div className="flex-1 min-w-0">
            <ArticleContent />
          </div>
          <div className="w-full lg:w-80 shrink-0 mt-8 lg:mt-24">
            <RelatedArticles />
          </div>
        </div>
      </main>
    </>
  );
}